"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_svg_1 = __importDefault(require("react-svg"));
exports.default = () => react_1.default.createElement(react_svg_1.default, { path: "https://static.ux.cimpress.io/assets/images/page_error_404.svg" });
